import { Button } from "../../../../../components/buttons/button";
import {
  BankLoader,
  SingleBankComponent,
} from "../../../../../components/cards/bankCard";
import { ContainerCard } from "../../../../../components/cards/containerCard";
import { InformationCard } from "../../../../../components/cards/infoCard";
import { AddBankAccountModal } from "../../../../../components/modals/app_modals/AddBankAccountModal";
import { EmptyState } from "../../../../../components/states/emptyState";
import { TitleSub } from "../../../../../components/typography/titleSub";
import { useModalControl } from "../../../../../customHooks/useModalControl";
import { useLazyGetUserProfileQuery } from "../../../../../redux/features/auth/auth.api";
import { useAppSelector } from "../../../../../redux/hooks";

export const CooperativeBankAccount = () => {
  const { modal, modalOpen, handleModalOpen, handleModalClose } =
    useModalControl();

  const { profile, onboardingCompletionStatus } = useAppSelector((state) => {
    return state?.auth;
  });

  const [fetchProfileDetails, { isLoading: fetchingProfileDetails }] =
    useLazyGetUserProfileQuery();

  return (
    <div className="flex flex-row flex-wrap width-lim:flex-nowrap w-full gap-2 md:gap-6">
      <ContainerCard
        className="
        !w-full width-lim:max-w-[653px] width-lim:min-h-[635px]
        order-last width-lim:order-first
        "
      >
        <div className="flex flex-wrap gap-4 items-center justify-between">
          <TitleSub
            title="Bank Account Details"
            subtitle={"Bank Account Linked to your Cooperative Account"}
            className={`w-fit md:max-w-max`}
          />

          {!!onboardingCompletionStatus?.isBankDetailsComplete ? undefined : (
            <Button
              text="Add account"
              icon="plus"
              onClick={() => {
                handleModalOpen("addBankAccountModal");
              }}
              type="button"
              className="!min-w-[82px] md:!min-w-[107px] !w-fit ml-auto"
              size="medium"
              loading={false}
              disabled={false}
              variation="primary"
            />
          )}
        </div>

        {fetchingProfileDetails ? (
          <div className="mt-8 flex flex-col gap-2">
            {[1].map((k) => {
              return <BankLoader key={`${k}`} />;
            })}
          </div>
        ) : (
          <>
            {onboardingCompletionStatus?.isBankDetailsComplete ? (
              <div className="mt-[32px] w-full">
                <SingleBankComponent
                  accountName={profile?.AccountName!}
                  accountNumber={profile?.AccountNumber!}
                  bankName={profile?.BankName!}
                  canDelete={false}
                />
              </div>
            ) : (
              <EmptyState
                image={
                  <img
                    src={"/assets/images/empty_state_bank.svg"}
                    alt="empty_state"
                    className=""
                  />
                }
                title="You have not added a bank account"
                subtitle={
                  "Add a bank account that is specifically used for your cooperative’s financial activities"
                }
                className="mt-20"
                actionText="Add a bank account"
                onClick={() => {
                  handleModalOpen("addBankAccountModal");
                }}
              />
            )}
          </>
        )}
      </ContainerCard>

      <InformationCard
        info={
          onboardingCompletionStatus?.isBankDetailsComplete ? (
            <p>
              To change your{" "}
              <span className="text-pry-green-200 font-medium">
                cooperative’s bank account
              </span>
              , please reach out to support.
            </p>
          ) : (
            "Kindly ensure you add the bank account that is tied to your cooperative financial activities"
          )
        }
        className="flex-1 width-lim:max-w-[345px] h-fit width-lim:sticky-top"
      />

      <AddBankAccountModal
        modalOpen={modalOpen && modal === "addBankAccountModal"}
        onModalClose={() => {
          handleModalClose();
        }}
        onSuccess={() => {
          // Update profile and onboarding completion status
          fetchProfileDetails();
          handleModalClose();
        }}
        type="cooperative"
      />
    </div>
  );
};
